module.exports = __webpack_public_path__ + "3a81ccfa54997821e1fba53128c6d266.jpg";